import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: '',
  currentPage: 1,
  hasNext: false,
  hasPrev: false,
  campaigns: [],
}

const campaignReportingSlice = createSlice({
  name: "campaignReportingSlice",
  initialState,
  reducers: {
    fetchCampaignReports: () => {
    },
    setLoading: (state) => {
      state.loading = true
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setCampaigns: (state, action) => {
      const {page, has_next, has_prev, data} = action.payload
      state.currentPage = page
      state.hasNext = has_next
      state.hasPrev = has_prev
      state.campaigns = data
      state.loading = false
    }
  }
})

export const {fetchCampaignReports, setLoading, setError, setCampaigns} = campaignReportingSlice.actions

export default campaignReportingSlice.reducer